import { supabase } from '../lib/supabase';

const toCamelCase = (obj) => {
  if (!obj) return obj;
  return {
    id: obj?.id,
    name: obj?.name,
    email: obj?.email,
    phone: obj?.phone,
    service: obj?.service,
    status: obj?.status,
    value: obj?.value,
    source: obj?.source,
    assignedTo: obj?.assigned_to,
    avatar: obj?.avatar,
    avatarAlt: obj?.avatar_alt,
    lastContact: obj?.last_contact,
    notes: obj?.notes,
    createdAt: obj?.created_at,
    updatedAt: obj?.updated_at,
  };
};

const toSnakeCase = (obj) => {
  return {
    name: obj?.name,
    email: obj?.email,
    phone: obj?.phone,
    service: obj?.service,
    status: obj?.status,
    value: obj?.value,
    source: obj?.source,
    assigned_to: obj?.assignedTo,
    avatar: obj?.avatar,
    avatar_alt: obj?.avatarAlt,
    last_contact: obj?.lastContact,
    notes: obj?.notes,
  };
};

const getAll = async () => {
  const { data, error } = await supabase?.from('leads')?.select('*')?.order('created_at', { ascending: false });

  if (error) throw error;
  return data?.map(toCamelCase) || [];
};

const getById = async (id) => {
  const { data, error } = await supabase?.from('leads')?.select('*')?.eq('id', id);

  if (error) throw error;
  return data?.[0] ? toCamelCase(data?.[0]) : null;
};

const create = async (leadData) => {
  const { data, error } = await supabase?.from('leads')?.insert([toSnakeCase(leadData)])?.select()?.single();

  if (error) throw error;
  return toCamelCase(data);
};

const update = async (id, leadData) => {
  const { data, error } = await supabase?.from('leads')?.update(toSnakeCase(leadData))?.eq('id', id)?.select()?.single();

  if (error) throw error;
  return toCamelCase(data);
};

const deleteMethod = async (id) => {
  const { error } = await supabase?.from('leads')?.delete()?.eq('id', id);

  if (error) throw error;
};

const subscribeToChanges = (callback) => {
  const channel = supabase?.channel('leads')?.on('postgres_changes', { event: '*', schema: 'public', table: 'leads' }, (payload) => {
      callback(payload);
    })?.subscribe();

  return () => supabase?.removeChannel(channel);
};

export const leadService = {
  getAll,
  getById,
  create,
  update,
  delete: deleteMethod,
  subscribeToChanges,
};
